import storage from 'proxy-storage'
import noop from '@hc-frontend/shared-assets/src/js/utils/fp/noop'
import updateLocationCopies from 'core/DOM/updateLocationCopies'
import buildControllerZipCounty from 'core/controllers/buildControllerZipCounty'
import buildControllerDOB from 'core/controllers/buildControllerDOB'
import buildControllerGender from 'core/controllers/buildControllerGender'
import buildControllerName from 'core/controllers/buildControllerName'
import buildControllerEmail from 'core/controllers/buildControllerEmail'
import { GREATER_THAN_64_YEARS_11_MONTHS } from 'core/controllers/validations/getErrorToDOB'
import handleMembers from './handleMembers'
import buildControllerPhone from 'core/controllers/buildControllerPhone'
import { MemberType } from '@hc-frontend/entities'
import { alterDate } from '@hc-frontend/utils'
import buildControllerTcpa from 'core/controllers/buildControllerTcpa'

const tomorrow = alterDate({ days: 1 })

function locationUpdateHandler(handler = noop) {
  return ({ appState, city, state, stateName, zip, county }) => {
    const hcStorage = storage.getItem('hc')

    hcStorage.location = {
      city: city,
      county: county,
      state: stateName,
      state_acronym: state,
      zip_code: zip
    }
    storage.setItem('hc', hcStorage)
    if (hcStorage.location.zip_code) {
      updateLocationCopies({ location: hcStorage.location })
    }
    handler(hcStorage, appState)
  }
}

function getControllerZipCode(form, handler, county = '') {
  const zipCounty = buildControllerZipCounty({
    form,
    handleUpdateLocation: locationUpdateHandler(handler),
    county
  })

  return zipCounty
}

function customDobErrorHandler(state, message) {
  const IsOlderThan64And11Months = message === GREATER_THAN_64_YEARS_11_MONTHS
  let errorMessage = message
  state.input.dataset.gap = IsOlderThan64And11Months ? 'gap65' : 'none'

  if (IsOlderThan64And11Months) {
    state.error = false
    state.valid = true
    window.dataLayerPushEvent('NO_COVERAGE_64_YEARS_11_MONTHS')
    errorMessage = ''
  } else {
    state.error = true
    state.valid = false
  }
  state.errorWrap.innerHTML = errorMessage
}

function initializerControllers(form, handleUpdateLocation, county) {
  function getSdate() {
    return tomorrow
  }

  handleMembers.setGetSdate(getSdate)
  const controllers = {
    zip: getControllerZipCode(form, handleUpdateLocation, county),
    dob: buildControllerDOB({
      input: form.dob,
      typeMember: MemberType.Applicant,
      getSdate,
      callOnFocus: state => (state.input.dataset.gap = ''),
      showError: customDobErrorHandler
    }),
    gender: buildControllerGender({ inputs: form.gender }),
    fname: buildControllerName({ input: form.fname }),
    phone: buildControllerPhone({ input: form.phone }),
    email: buildControllerEmail({ input: form.email }),
    leadIdToken: buildControllerTcpa({ input: form.leadid_token }),
    period: (function () {
      const state = {
        valid: true,
        value: '',
        options: []
      }

      return {
        setValue: ({ data, period }) => {
          state.value = `${period}`
          state.options = data
        },
        getStatus: () => {
          return state
        },
        validate: noop
      }
    })()
  }

  return controllers
}

export default initializerControllers
